<script>
/* global $ */
import Vue from 'vue';
import VueDist from 'vue/dist/vue.min.js';
import { factory as personalAccountButtonFactory } from '@/components/PersonalAccountChoiceModal/PersonalAccountButton';
import Cities from '../City/UserCity.vue';
import scrollToElement from '../../helpers/scroll-to-element';
import { targetsYmOnElements } from '../../helpers/targets-ym';

const mobileHeaderMenu = {
  el: '#headerMobile',
  name: 'MobileHeaderMenu',
  props: {
    // Изменяет поведение клика по иконке калькулятора на вложенных страницах (true - клик переводит на основную страницу)
    subpage: {
      type: Boolean,
      default: false,
    },
    // Измененяет поведение клика по иконке калькулятора (true - клик открывает вложенное меню, false - клик якорит к калькулятору)
    subMenuCalc: {
      type: Boolean,
      default: true,
    },
    // Если значение true, при инициализации компонента произойдет скролл к калькулятору ПиП.
    scrollToCalc: {
      type: Boolean,
      default: false,
    },
    // Если значение true, при инициализации компонента произойдет скролл к калькулятору ИМ.
    scrollToCalcIM: {
      type: Boolean,
      default: false,
    },
    // Измененяет поведение клика по иконке трекинга (true - клик открывает вложенное меню, false - клик скроллит к формбару трекинга)
    subMenuFindTrack: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showSectionsSite: false,
      showMobileMenu: false,
      showFindTrack: false,
      showCalculator: false,
      $subMenuItem: [],
      trackFind: '',
      showMobileHeaderMenu: $(window).width() > 580,
      scrollPos: 0,
    };
  },
  created() {
  },
  beforeMount() {
    const page = document.querySelector('.page');
    if (page) {
      page.classList.add('page_with-header');
    }
  },
  mounted() {
    const self = this;
    this.$subMenuItem = $(this.$el).find('.header-dropdown__item_submenu');

    this.hideDesktopMenu();
    this.initShowSubMenuItems();
    document.addEventListener('scroll', this.toggleHideMobileHeaderPart);

    document.addEventListener('click', (e) => {
      if (!$(e.target).closest($(self.$refs.dropdown_sections_site)).length) {
        self.showSectionsSite = false;
      }
    });

    ['resize', 'orientationchange'].forEach(
      (eventName) => {
        window.addEventListener(eventName, () => {
          setTimeout(() => {
            self.hideDesktopMenu();
          }, 500);
        });
      },
    );

    if (document.getElementById('mobileMenuCitySelect')) {
      new Vue({
        render: (h) => h(Cities),
      }).$mount('#mobileMenuCitySelect');
    }

    if (this.scrollToCalc) {
      this.onScrollToCalc();
      // eslint-disable-next-line
      history.pushState('', document.title, window.location.pathname);
    } else if (this.scrollToCalcIM) {
      this.onScrollToCalcIM();
      // eslint-disable-next-line
      history.pushState('', document.title, window.location.pathname);
    }

    const tabsHeaderMobile = document.querySelectorAll('.header-mobile .header__dropdown .dropdown__items .dropdown__item');
    const arrayIdTargets = ['all_private_clients', 'all_online_store', 'all_business_partner', 'all_International_delivery', 'all_about'];

    targetsYmOnElements(tabsHeaderMobile, arrayIdTargets);

    personalAccountButtonFactory({
      buttonClass: 'button button_transparent button_red-border header-dropdown__field button_text-left button-personal-accounts',
      iconId: '#entity-green',
      iconClass: 'entity-icon',
      restorePopupMode: 'none',
      el: '.button-personal-accounts',
    });

    personalAccountButtonFactory({
      buttonClass: 'header-mobile__login',
      label: 'Вход',
      iconId: '#entity',
      iconClass: 'entity-icon',
      restorePopupMode: 'mobile',
      el: '.header-mobile__login',
    });
  },
  methods: {
    hideDesktopMenu() {
      if (window.innerWidth < 580) {
        $('.header-desktop').css({
          opacity: 0,
          visibility: 'hidden',
        });
      } else {
        $('.header-desktop').css({
          opacity: 1,
          visibility: 'visible',
        });
      }
    },
    toggleHideMobileHeaderPart() {
      const st = $(window).scrollTop();
      if (st > 0) {
        if (st > this.scrollPos) {
          $(this.$el).addClass('header-mobile__hidden');
        } else {
          $(this.$el).removeClass('header-mobile__hidden');
        }
        this.scrollPos = st;
      } else {
        $(this.$el).removeClass('header-mobile__hidden');
      }
    },
    onScrollToCalc() {
      this.showCalculator = false;
      this.scrollToElement('.calculator', 'smooth');
    },
    onScrollToCalcIM() {
      this.scrollToElement('.calculator-im', 'auto');
    },
    scrollToElement(selector, behavior) {
      const element = $(selector).offset();

      if (element) {
        const header = window.scrollY <= element.top
          ? document.querySelector('.mobile-header-tabs') : document.querySelector('.header-mobile');

        if (header) {
          window.scrollTo({
            top: element.top - header.clientHeight,
            behavior,
          });
        }
      }
    },
    onTrackFind() {
      document.dispatchEvent(new CustomEvent('startSearchTrack', { detail: { track: this.trackFind } }));
    },
    onShowMobileCalculator() {
      if (!this.subMenuCalc && !this.subpage) {
        this.hideAllTabs();
        this.onScrollToCalcIM();
      } else if (!this.subMenuCalc && this.subpage) {
        window.location.href = `${window.location.origin}/e-commerce#calcIM`;
      } else if (this.showCalculator) {
        this.showCalculator = false;
        // this.removeItemListener();
      } else {
        this.hideAllTabs();
        this.showCalculator = true;
        // this.initShowSubMenuItems();
      }
    },
    onShowMobileFindTrack() {
      if (!this.subMenuFindTrack) {
        this.hideAllTabs();
        const header = document.querySelector('.mobile-header');
        const trackWidget = document.querySelector('.track-widget');
        if (header && trackWidget) {
          scrollToElement(trackWidget, header, 0);
        }
      } else if (this.showFindTrack) {
        this.showFindTrack = false;
        // this.removeItemListener();
      } else {
        this.hideAllTabs();
        this.showFindTrack = true;
        // this.initShowSubMenuItems();
      }
    },
    onShowMobileMenu() {
      if (this.showMobileMenu) {
        this.showMobileMenu = false;
        // this.removeItemListener();
      } else {
        this.hideAllTabs();
        this.showMobileMenu = true;
        // this.initShowSubMenuItems();
      }
    },
    onShowSectionsSite() {
      if (this.showSectionsSite) {
        this.showSectionsSite = false;
      } else {
        this.hideAllTabs();
        this.showSectionsSite = true;
      }
    },
    hideAllTabs() {
      this.showSectionsSite = false;
      this.showMobileMenu = false;
      this.showFindTrack = false;
      this.showCalculator = false;
      // this.removeItemListener();
    },
    initShowSubMenuItems() {
      const self = this;

      if (this.$subMenuItem.length) {
        this.$subMenuItem.each((i) => {
          $(self.$subMenuItem[i]).find('.header-dropdown__title').on('click', self.toggleShowSubItem);
        });
      }
    },
    toggleShowSubItem(e) {
      e.preventDefault();
      $(e.currentTarget).parent().toggleClass('header-dropdown__item_active');
    },
    removeItemListener() {
      const self = this;

      if (this.$subMenuItem.length) {
        this.$subMenuItem.each((i) => {
          $(self.$subMenuItem[i]).off('click', self.toggleShowSubItem);
        });
      }
    },
    routeToCalc() {
      if (!this.subpage) {
        this.onScrollToCalc();
      } else {
        window.location.href = `${window.location.origin}/#calc`;
      }
    },
    openAccountMenu() {
      dispatchEvent(new CustomEvent('click-button-accounts'));
    },
  },
};

const factory = function (options) {
  return new VueDist({
    ...mobileHeaderMenu,
    propsData: options,
  });
};

export { mobileHeaderMenu as default, factory };
</script>

<style lang="scss" scoped>

  .header-mobile {
    opacity: 0;
    visibility: hidden;

    @media (max-width: 580px) {
      display: block;
      opacity: 1;
      visibility: visible;
    }
  }

</style>

<style lang="scss">
  @import "./MobileHeaderMenu.scss";
</style>
